import React, { useEffect, useState } from "react";
import {
  afl_logo_white,
  afl_logo_white_two,
  dashboard_car,
  dashboard_icon,
  dashboard_list_my_car,
  dashboard_logout,
  sidebar_collapse_icon,
  aaa_second_logo,
  logo_aaa,
} from "../../../assets/images";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearBookingValues } from "../../../Redux/BookingData/bookingDataSlice";
import { afl_log_out } from "../../../services/axios.instance";

const dataNavTop = [
  {
    label: "Dashboard",
    icon: dashboard_icon,
    value: "dashboard",
    navlink: "/vendor/dashboard",
  },
  // {
  //   label: "Service Creation",
  //   icon: dashboard_car,
  //   value: "servicecreation",
  //   navlink: "/dashboard/servicecreation",
  // },
  {
    label: "Service List",
    icon: dashboard_list_my_car,
    value: "servicelist",
    navlink: "/vendor/dashboard/servicelist",
  },
  {
    label: "Driver Approval",
    icon: dashboard_car,
    value: "driverapproval",
    navlink: "/vendor/dashboard/driverapproval",
  },
  {
    label: "Driver OTP",
    icon: dashboard_car,
    value: "driverotp",
    navlink: "/vendor/dashboard/driverotp",
  },
];

interface MerchantDashboardSidebarProps {
  currentPage: string;
  setCurrentPage: (page: string) => void;
}

const VendorSidebar: React.FC<MerchantDashboardSidebarProps> = ({
  setCurrentPage,
}) => {
  const [selectedNav, setSelectedNav] = useState("dashboard");
  const [selectedNavToggle, setSelectedNavToggle] = useState(true);
  // const [newNotificationsCount, setNewNotificationsCount] = useState(0);

  //-------------------------
  const path_location = useLocation();

  useEffect(() => {
    if (path_location.pathname === "/vendor/dashboard/servicelist") {
      handleSetActiveNavigation("servicelist");
    }
    // if (path_location.pathname === "/dashboard/servicecreation") {
    //   handleSetActiveNavigation("servicecreation");
    // }
    if (path_location.pathname === "/dashboard/servicelist/servicedetails") {
      handleSetActiveNavigation("servicelist");
    }
    if (path_location.pathname === "/vendor/dashboard/driverapproval") {
      handleSetActiveNavigation("driverapproval");
    }
    if (path_location.pathname === "/vendor/dashboard/driverotp") {
      handleSetActiveNavigation("driverotp");
    }
  }, [path_location.pathname]);

  //-----------------------

  const handleSetNavToggle = () => {
    setSelectedNavToggle(!selectedNavToggle);
  };

  const handleSetActiveNavigation = (nav: string) => {
    setSelectedNav(nav);
    setCurrentPage(nav);
  };

  const dispatch = useDispatch();
  const decodeToken = (token: string | null) => {
    if (token) {
      return JSON.parse(atob(token.split(".")[1]));
    }
    return null;
  };

  const handleSetActiveNavigationLogout = (nav: string) => {
    const token = localStorage.getItem("access_token");
    const decoded = decodeToken(token);
    const roles = decoded?.roles || [];

    // First perform the logout and clear booking values
    afl_log_out()
      .then(() => {
        dispatch(clearBookingValues());
        // After logout is complete, redirect based on role
        if (roles.includes("ROLE_AAA_USER")) {
          window.location.href = "/aaa";
        } else if (roles.includes("ROLE_AFL_USER")) {
          window.location.href = "/afl";
        } else {
          window.location.href = "/";
        }
      })
      .catch((error) => {
        console.error("Error during logout:", error);
        dispatch(clearBookingValues());
        // Still try to redirect even if there was an error during logout
        if (roles.includes("ROLE_AAA_USER")) {
          window.location.href = "/aaa";
        } else if (roles.includes("ROLE_AFL_USER")) {
          window.location.href = "/afl";
        } else {
          window.location.href = "/";
        }
      });
  };

  return (
    <div
      className={` px-0 bg-black align-items-center sidebar-min-width ${
        selectedNavToggle
          ? "col-1"
          : "col-auto col-md-3 col-xl-2 responsive-sidebar-ab"
      }`}
    >
      <div 
        className="sidebar-dash d-flex flex-column align-items-center px-3 pt-2 text-white min-vh-100"
        style={{
          overflow: selectedNavToggle ? "visible" : "hidden",
          overflowY: selectedNavToggle ? "visible" : "auto"
        }}
      >
        <div className="  text-end toggle-sidebar-btn-div">
          <button className="toggle-sidebar-btn" onClick={handleSetNavToggle}>
            <img
              src={sidebar_collapse_icon}
              alt=""
              className="toggle-sidebar-btn-icon"
            />
          </button>
        </div>
        <div className="text-center mb-3 mt-2 div-logo-sidebar">
          <Link
            to="#"
            className={` align-items-center ${
              selectedNavToggle ? "sidebar-icon-toggle" : ""
            }`}
          >
            <img
              // src={dashboard_logo_kirkos}
              src={selectedNavToggle ? logo_aaa : aaa_second_logo}
              // width="80%"
              // height="80%"
              style={{ minWidth: "45px" }}
              alt="Logo"
              className="img-fluid ps-2"
            />
          </Link>
        </div>
        <ul
          className="nav nav-tabs flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start nav-tab-style pt-"
          id="side-bar-menu"
        >
          {dataNavTop.map((item) => (
            <li
              className="nav-item sidebar-list position-relative"
              key={item.value}
            >
              <div className="dashboard-side-bar-link-div">
                <Link
                  to={item.navlink}
                  onClick={() => handleSetActiveNavigation(item.value)}
                  className={`nav-link align-items-center px-1 d-flex dashboard-side-bar-link ${
                    selectedNav === item.value ? "active-class" : ""
                  }`}
                >
                  <i className="">
                    <img src={item.icon} width="15" height="15" />
                  </i>

                  <span
                    className={`ms-1 label-sidebar label-sidebar-customer ${
                      selectedNavToggle ? "d-none-custom" : ""
                    }`}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {item.label}
                  </span>

                  {/* Tooltip (only show when sidebar collapsed) */}
                  {selectedNavToggle && (
                    <div className="sidebar-tooltip" style={{ left: "calc(100% + 15px)" }}>{item.label}</div>
                  )}
                </Link>
              </div>
            </li>
          ))}
        </ul>

        <ul
          className="nav nav-tabs flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start nav-tab-style"
          id="menu2"
        >
          <li className="nav-item p-1 sidebar-list">
            <div className="dashboard-side-bar-link-div">
              <Link
                to="/afl"
                onClick={() => handleSetActiveNavigationLogout("logout")}
                className={`nav-link align-items-center px-1 d-flex dashboard-side-bar-link  ${
                  selectedNav === "logout" ? "active-class" : ""
                }`}
              >
                <i className="">
                  <img src={dashboard_logout} width="15" height="15" />
                </i>
                <span
                  className={`ms-1  label-sidebar label-sidebar-customer ${
                    selectedNavToggle ? "d-none-custom" : ""
                  }`}
                  style={{ whiteSpace: "nowrap" }}
                >
                  Logout
                </span>
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default VendorSidebar;
